import { useState, useEffect, useCallback } from 'react';

export const useEnhancedLoading = () => {
    const [stepTransitions, setStepTransitions] = useState([]);
    const [lastStep, setLastStep] = useState(1);

    // Track step transitions
    useEffect(() => {
        if (lastStep !== null && lastStep > 1) {
            setStepTransitions(prev => [...prev, {
                from: lastStep - 1,
                to: lastStep,
                timestamp: Date.now()
            }]);
        }
    }, [lastStep]);

    // Update current step
    const updateStep = useCallback((newStep) => {
        setLastStep(newStep);
    }, []);

    // Get step completion history
    const getStepHistory = useCallback(() => {
        return stepTransitions.map(transition => ({
            ...transition,
            duration: transition.timestamp - (stepTransitions[stepTransitions.length - 2]?.timestamp || 0)
        }));
    }, [stepTransitions]);

    return {
        updateStep,
        stepTransitions,
        getStepHistory
    };
};

export default useEnhancedLoading; 